import { AxiosError } from 'axios';
import { get } from '../api/api';
import { STATUS_CODE } from '../constants/constants';

/**
 * Lets a 409 reach the caller as a raw axios error instead of the global error page, so the form
 * stays open with what the user typed and they can save again.
 */
export const VERSION_CONFLICT_CONFIG = { handlesVersionConflict: true };

export const isVersionConflictError = (error: unknown): boolean =>
  (error as AxiosError | undefined)?.response?.status === STATUS_CODE.CONFLICT;

export const fetchRecordVersion = async (recordUrl: string): Promise<string | undefined> => {
  const record = await get(recordUrl, {}, { skipGlobalErrorHandler: true });
  return record?.version;
};
